import { render } from "./article-set.vue?vue&type=template&id=f8583b54&scoped=true&ts=true"
import script from "./article-set.vue?vue&type=script&lang=ts"
export * from "./article-set.vue?vue&type=script&lang=ts"

import "./article-set.vue?vue&type=style&index=0&id=f8583b54&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8583b54"]])

export default __exports__